import { message } from 'antd';
import dayjs from 'dayjs';
import domToImage from 'dom-to-image';
import { t } from 'i18next';
import { getTerminalMode } from 'utils/terminal';

type TPurchaseTicketProps = {
  userName: string;
  transactionId: string;
  nftName: string;
  nftPrice: string;
  mintPrice: string;
  vatPrice: string;
  totalPrice: string;
};

const PurchaseTicketDefaultProps: TPurchaseTicketProps = {
  userName: 'Test User',
  transactionId: '1234567890',
  nftName: 'Test Nft',
  nftPrice: '100 AED',
  mintPrice: '10 AED',
  vatPrice: '5 AED',
  totalPrice: '115 AED'
};

export const createTicketBase64 = (props = PurchaseTicketDefaultProps) => {
  const isTerminalMode = getTerminalMode();
  const terminalName = JSON.parse(
    localStorage.getItem('terminalName') || 'null'
  );
  const pageSizes = isTerminalMode
    ? 'height=600, width=260'
    : 'height=650, width=500';
  const ticketPage = window.open('', '', pageSizes);
  if (ticketPage) {
    const ticketPageContent = `<html lang="en">
      <style>
          body {
              width: 260px;
              height: 650px;
              font-family: Verdana, sans-serif;
          }
          .block {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
          }
          .centered {
              display: flex;
              text-align: center;
              align-items: center;
              justify-content: center;
              word-break: break-word;
          }
          .disclaimer-container {
              margin-bottom: 10px;
          }
          .disclaimer-title {
              font-size: 12px;
              margin-bottom: 5px;
          }
          .disclaimer-text-container {
              display: flex;
              flex-direction: column;
              gap: 4px;
              font-size: 10px;
              line-height: 1;
              margin-bottom: 5px;
              
              p {
                  margin-top: 0;
              }
          }
      </style>
      <body>
        <div class="centered">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.4956 37.9097V41.2443H17.8877V42.7329H22.4956V45.3963H17.8877V48.0055H14.4734V37.9097H22.4956Z" fill="#0A0A0A"/>
                <path d="M33.5328 37.9097V41.1577H30.4405V47.973H26.9373V41.1847H23.845V37.9367L33.5328 37.9097Z" fill="#0A0A0A"/>
                <path d="M2.58722 37.9097H5.84051L9.52129 42.3648V37.9097H12.9467V48.0001H9.87105L6.0348 43.3446V48.0001H2.60941L2.58722 37.9097Z" fill="#0A0A0A"/>
                <path d="M12.9584 14.3289V16.5754H16.0674V23.0227H12.9584V35.1053H2.5934V23.0227H0.000732422V16.4509H2.5934L2.95424 13.4195C3.43909 9.54712 6.47957 7.61096 12.0757 7.61096C13.9859 7.64938 15.8911 7.8176 17.7773 8.1144L17.2221 14.7349L12.9584 14.3289Z" fill="#0A0A0A"/>
                <path d="M18.4327 23.0284V16.5324H21.0253V12.4887L31.3792 8.76428V16.4891H34.9601V22.9851H31.3792V27.895C32.2786 28.0628 33.983 27.9545 35.1266 28.0249L33.6221 36.0529C28.8865 36.0529 26.1662 35.4249 24.7394 34.9215C22.974 34.3152 21.8692 33.5032 21.4084 32.4963C21.1198 31.8251 20.9798 31.1019 20.9976 30.3743V23.0284H18.4327Z" fill="#0A0A0A"/>
                <path d="M44.2815 0.227505C42.3899 -0.0756721 40.4603 -0.0756721 38.5688 0.227505C37.6939 0.369339 36.8863 0.77435 36.2592 1.38587C35.6321 1.99738 35.2167 2.78482 35.0712 3.63793C34.7547 5.4837 34.7547 7.36789 35.0712 9.21365C35.2167 10.0668 35.6321 10.8542 36.2592 11.4657C36.8863 12.0772 37.6939 12.4822 38.5688 12.624C40.4612 12.9164 42.3891 12.9164 44.2815 12.624C45.1551 12.4804 45.9609 12.0747 46.5869 11.4634C47.2128 10.8521 47.6276 10.0657 47.7735 9.21365C47.9297 8.2959 48.0058 7.3669 48.0011 6.43661C48.0014 5.50268 47.9234 4.57028 47.768 3.64873C47.6213 2.79845 47.2069 2.01377 46.5821 1.40361C45.9573 0.793445 45.1533 0.38808 44.2815 0.24376V0.227505ZM40.1233 10.6698C40.0383 10.6691 39.9544 10.652 39.8762 10.6195C39.7981 10.5869 39.7273 10.5397 39.668 10.4804C39.5609 10.3744 39.495 10.2353 39.4819 10.087C39.4687 9.9388 39.509 9.79071 39.5958 9.66835L41.2114 7.47054L38.5355 7.22155C38.3931 7.20905 38.2577 7.15625 38.1457 7.06963C38.0338 6.98302 37.9502 6.86635 37.9054 6.73404C37.8605 6.60173 37.8563 6.45954 37.8933 6.32494C37.9303 6.19033 38.0069 6.06919 38.1136 5.97646L42.2773 2.3333C42.3977 2.22778 42.5541 2.16987 42.7159 2.1709C42.8005 2.17064 42.8843 2.18679 42.9625 2.21838C43.0406 2.24998 43.1116 2.29638 43.1711 2.35494C43.2788 2.46191 43.3446 2.60242 43.3567 2.75185C43.3689 2.90129 43.3268 3.05014 43.2378 3.17236L41.6222 5.36475L44.3037 5.61377C44.4448 5.62852 44.5784 5.68257 44.6888 5.76946C44.7992 5.85635 44.8816 5.97243 44.9261 6.10376C44.9706 6.2351 44.9753 6.37615 44.9398 6.51006C44.9043 6.64397 44.8299 6.76505 44.7256 6.85883L40.5618 10.502C40.442 10.6091 40.2857 10.6689 40.1233 10.6698Z" fill="#0A0A0A"/>
            </svg>
        </div>
        <br />
        ${
          terminalName
            ? `<div class="centered"><b>${terminalName}</b></div>`
            : ''
        }
        <div class="centered"><b>${t('payment.receiptSubheader')}</b></div>
        <br />
        <div class="block">
          <div>${t('generic.name')}</div>
          <div>${props.userName}</div>
        </div>
        <div class="block">
          <div>${t('payment.transactionId')}</div>
          <div>${props.transactionId}</div>
        </div>
        <div class="block">
          <div>TRN</div>
          <div>100577507500003</div>
        </div>
        <div class="block">
          <div>${t('payment.date')}</div>
          <div>${dayjs().format('DD/MM/YYYY')}</div>
        </div>
        <div class="block">
          <div>${t('payment.time')}</div>
          <div>${dayjs().format('HH:mm:ss')}</div>
        </div>
        <div class="block">
          <div>${t('payment.paymentMethod')}</div>
          <div>${t('payment.paymentMethodName')}</div>
        </div>
        <hr />
        <div class="block">
          <div>${t('payment.nftName')}</div>
          <div>${props.nftName}</div>
        </div>
        <hr />
        <div class="block">
          <div>${t('nft.nftPrice')}</div>
          <div>${props.nftPrice}</div>
        </div>
        <div class="block">
          <div>${t('nft.mintPrice')}</div>
          <div>${props.mintPrice}</div>
        </div>
        <div class="block">
          <div>${t('nft.VAT')}</div>
          <div>${props.mintPrice}</div>
        </div>
        <div class="block">
          <div><b>${t('nft.totalPrice')}</b></div>
          <div><b>${props.totalPrice}</b></div>
        </div>
        <br />
        <div class="centered">${t('payment.receiptDisclaimer')}</div>
      </body>
    </html>`;
    ticketPage.document.write(ticketPageContent);
    ticketPage.document.close();

    if (!isTerminalMode) {
      ticketPage.print();
      return;
    }

    domToImage
      .toPng(ticketPage?.document.documentElement)
      .then(dataUrl => {
        const base64Value = dataUrl.split(',')[1];
        ticketPage.close();
        window.external.printBase64Ticket(base64Value || '');
        return;
      })
      .catch(error => {
        if (error instanceof Error) {
          message.error(error.message);
        } else {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }
  return;
};
